'use strict';

import { GLOBAL } from './Global';
import { SMART_CAMPAIGN_V2 as SMART_CAMPAIGN_V2_PERMISSION_GROUPS } from '../PermissionsGroups';

const smart_campaign_v2_permissions_list = [];

for (const [key, value] of Object.entries(SMART_CAMPAIGN_V2_PERMISSION_GROUPS)) {
  smart_campaign_v2_permissions_list.push({
    action_list: value,
    element: key,
  });
}

const SMART_CAMPAIGN_V2 = {
  can: [
    ...GLOBAL.can,
    ...smart_campaign_v2_permissions_list,
  ],
};

export {
  SMART_CAMPAIGN_V2,
};
